
import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router';

const CareersListingPage = lazy(() => import('./pages/CareersListingPage'));


export const careersRoutes: routeItem[] = [
  {
    path: 'careers',
    element: <Outlet/>,
    children: [
      {
        index: true,
        element: <CareersListingPage />,
      },
    ],
  },
  
];